import { Link } from 'gatsby';
import PropTypes from 'prop-types';
import React from 'react';
import { FaArrowLeft } from '@react-icons/all-files/fa/FaArrowLeft';
import { FaArrowRight } from '@react-icons/all-files/fa/FaArrowRight';
import { MdOpenInBrowser } from '@react-icons/all-files/md/MdOpenInBrowser';
import { getLocaleDateString } from '../../utils/helpers';

import { styled } from '@linaria/react';
const NextPrev = (props) => {
  const {
    theme,
    nextMarkdownPost: {
      fields: { prefix: nextPrefix, slug: nextSlug } = {},
      frontmatter: { title: nextTitle } = {},
    } = {},
    prevMarkdownPost: {
      fields: { prefix: prevPrefix, slug: prevSlug } = {},
      frontmatter: { title: prevTitle } = {},
    } = {},
    nextContentfulPost,
    prevContentfulPost,
  } = props;

  const nextPostSlug = nextSlug ? nextSlug : nextContentfulPost?.slug;
  const prevPostSlug = prevSlug ? prevSlug : prevContentfulPost?.slug;
  const nextPostTitle = nextTitle ? nextTitle : nextContentfulPost?.title;
  const prevPostTitle = prevTitle ? prevTitle : prevContentfulPost?.title;
  const nextDatePublished = nextPrefix ? nextPrefix : nextContentfulPost?.datePublished;
  const prevDatePublished = prevPrefix ? prevPrefix : prevContentfulPost?.datePublished;

  return (
    <React.Fragment>
      {nextPostSlug && prevPostSlug && (
        <LinksStyled theme={theme}>
          {nextPostSlug && (
            <Link to={nextPostSlug}>
              <H4Styled>
                {nextPostTitle}
                <TimeStyled theme={theme}>
                  <MdOpenInBrowser size={22} />
                  <TimeStyledText>{getLocaleDateString(nextDatePublished)}</TimeStyledText>
                </TimeStyled>
              </H4Styled>
              <FaArrowRight className={'arrow'} style={{ marginLeft: '10px' }} />
            </Link>
          )}
          {prevPostSlug && (
            <Link to={prevPostSlug}>
              <FaArrowLeft className={'arrow'} style={{ marginRight: '10px' }} />
              <H4Styled>
                {prevPostTitle}
                <TimeStyled theme={theme}>
                  <MdOpenInBrowser size={22} />
                  <TimeStyledText>{getLocaleDateString(prevDatePublished)}</TimeStyledText>
                </TimeStyled>
              </H4Styled>
            </Link>
          )}
        </LinksStyled>
      )}
    </React.Fragment>
  );
};

NextPrev.propTypes = {
  nextMarkdownPost: PropTypes.object,
  prevMarkdownPost: PropTypes.object,
  nextContentfulPost: PropTypes.object,
  prevContentfulPost: PropTypes.object,
  theme: PropTypes.object.isRequired,
};

export default NextPrev;

const LinksStyled = styled.div`
  display: flex;
  flex-direction: column;
  padding: ${(props) => props.theme.space.l} ${(props) => props.theme.space.m};
  border-top: 1px solid ${(props) => props.theme.line.color};
  border-bottom: 1px solid ${(props) => props.theme.line.color};
  margin: 40px 0 40px 0;

  a {
    color: var(--textLink);
    display: flex;
    justify-content: center;
  }

  a:nth-child(2) {
    margin: ${(props) => props.theme.space.default} 0 0;
  }

  svg {
    fill: ${(props) => props.theme.color.special.attention};
    width: ${(props) => props.theme.space.m};
    height: ${(props) => props.theme.space.m};
    flex-shrink: 0;
    flex-grow: 0;
    margin: ${(props) => props.theme.space.inline.m};
  }

  @media (min-width: 1024px) {
    flex-direction: row-reverse;
    justify-content: center;

    a {
      flex-basis: 50%;
      padding: 0px 15px;
    }

    a:nth-child(2) {
      margin: 0;
    }

    svg {
      transition: all 0.5s;
      margin: ${(props) => props.theme.space.inline.s};
    }

    @media (hover: hover) {
      a:hover svg.arrow {
        transform: scale(1.5);
      }
    }
  }
`;

const H4Styled = styled.h4`
  font-weight: 600;
  margin: 0;
  font-size: 1.1em;
`;

const TimeStyled = styled.time`
  color: ${(props) => props.theme.color.neutral.gray.g};
  display: flex;
  font-size: 0.9em;
  margin-top: 0.5em;
`;
const TimeStyledText = styled.span`
  align-self: center;
`;
